import apicaller from "@/utils/apicaller";
import api from "../../main.api";
import { cddRejectOnError } from "./cddResponse";

export default {
  getAll(params) {
    return apicaller.get(api.CDD.periods, { params });
  },
  getById(id) {
    return apicaller.get(`${api.CDD.period}/get/${id}`);
  },
  create(payload) {
    return apicaller
      .post(`${api.CDD.period}/create`, payload)
      .then(cddRejectOnError);
  },
  update(id, payload) {
    return apicaller
      .post(`${api.CDD.period}/update`, { ...payload, id })
      .then(cddRejectOnError);
  },
  delete(id) {
    return apicaller.post(`${api.CDD.period}/delete/${id}`, {});
  },
  activate(id) {
    return apicaller
      .post(`${api.CDD.period}/activate/${id}`, {})
      .then(cddRejectOnError);
  },
  pause(id) {
    return apicaller.post(`${api.CDD.period}/pause/${id}`, {});
  },
  trigger(id) {
    return apicaller
      .post(`${api.CDD.period}/trigger/${id}`, {})
      .then(cddRejectOnError);
  },
  preview(id) {
    return apicaller.post(`${api.CDD.period}/preview/${id}`, {});
  },
  previewQuery(queryId) {
    return apicaller.post(api.CDD.periodPreviewQuery, { queryId });
  },
  getHistory(id) {
    return apicaller.get(`${api.CDD.period}/history/${id}`);
  }
};
